import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchDirectorSummary } from 'queries/insights/insights'
import { useEssentials } from 'hooks/utils/useEssentials'
import { TIME } from 'utils/misc'
import { IGenericResponse } from 'utils/api'
import { DirectorSummaryResponse } from 'types/insights'
import { useAnalytics } from '../../utils/analytics'

export const useDirectorSummary = (
    shouldCallApi: boolean = true,
): IGenericResponse<DirectorSummaryResponse> => {
    const { session, params, env } = useEssentials()
    const { trackEvent } = useAnalytics()

    const { oneHour } = TIME
    const numericLocation = params.get('locationId')?.replace(/\D/g, '') ?? ''

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.INSIGHTS_DIRECTOR_SUMMARY, numericLocation],
        () =>
            fetchDirectorSummary(numericLocation)({
                env,
                accessToken: session?.accessToken ?? '',
                method: 'GET',
                trackEvent,
            }),
        {
            enabled: shouldCallApi,
            staleTime: oneHour,
            cacheTime: oneHour,
            retry: false,
            refetchOnWindowFocus: true,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
